<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <example-title src="example-1.html" title="Default" />
    <vc-radio-group @input="onInput({value: $event, group: 'guitars'})" name="guitars" v-model="mGuitars">
      <vc-radio v-for="(guitar, index) in guitars" :value="guitar" :key="index">{{ guitar }}</vc-radio>
    </vc-radio-group>
    <div :class="['mt-16']">
      <code>v-model: {{ mGuitars }}</code>
    </div>

    <example-title src="example-2.html" title="Horizontal group, custom color" />
    <vc-radio-group @input="onInput({value: $event, group: 'amps'})" name="amps" direction="horizontal" v-model="mAmps" color="red">
      <vc-radio v-for="(amp, index) in amps" :value="amp" :key="index">{{ amp }}</vc-radio>
    </vc-radio-group>
    <div :class="['mt-16']">
      <code>v-model: {{ mAmps }}</code>
    </div>

    <example-title src="example-3.html" title="Horizontal group, left label position and custom color" />
    <vc-radio-group @input="onInput({value: $event, group: 'drums'})" name="drums" label-position="left" direction="horizontal" v-model="mDrums" color="primary">
      <vc-radio v-for="(drum, index) in drums" :value="drum" :key="index">{{ drum }}</vc-radio>
    </vc-radio-group>
    <div :class="['mt-16']">
      <code>v-model: {{ mDrums }}</code>
    </div>

    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'RadioGroupPage',
  data () {
    return {
      title: null,
      description: null,
      guitars: ['Jackson', 'B.C. Rich', 'ESP', 'Epiphone'],
      amps: ['Carvin', 'Marshall', 'Peavey', 'Fender'],
      drums: ['Gretsch', 'Tama', 'Pearl', 'Mapex'],
      mGuitars: 'B.C. Rich',
      mAmps: 'Peavey',
      mDrums: 'Mapex'
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  },
  methods: {
    onInput (event) {
      console.log('vc-radio:input', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/radio-group.vue